import { faChevronDown } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { useNavigate } from 'react-router-dom'

export default function Landing({ }) {
    const navigate = useNavigate()
    return (
        <>
            <div style={{ fontFamily: 'MavenPro', backgroundImage: `url(${require("../assets/home.png")})`, backgroundRepeat: 'no-repeat', backgroundSize: '100% 100%' }} className='absolute z-[10] flex flex-col w-full h-[100vh]'>
                <div className='flex items-center gap-10'>
                    <img src={require('../assets/RAFCE-logo-white.png')} className='mr-[210px] ml-28' alt='logo' style={{ height: '8rem' }} />
                    <div>Solution</div>
                    <div>Documentation</div>
                    <div>Contact</div>
                </div>
                <div style={{ fontFamily: 'NexaHeavy' }} className='flex flex-col flex-1 pt-20'>
                    <div className='ml-32'>
                        <div className='text-7xl font-bold mb-2'>
                            Welcome to
                        </div>
                        <div style={{ fontWeight: 'bolder' }} className='text-7xl'>
                            RAFCE
                        </div>
                        <div style={{ fontFamily: '' }} className='text-lg font-bold my-4'>
                            GET STARTED WITH RISK ANALYSIS TODAY
                        </div>
                        <div style={{ fontFamily: 'NexaLight' }} className='text-2xl'>
                            Jump right in. You can begin
                        </div>
                        <div style={{ fontFamily: 'NexaLight' }} className='text-2xl'>
                            by creating a project
                        </div>
                        <div style={{ fontFamily: 'NexaLight' }} className='text-2xl'>
                            right away
                        </div>
                        <div className='flex items-center justify-start'>
                            <div onClick={() => navigate('/login')} style={{ backgroundImage: `url(${require("../assets/button_main.png")})`, backgroundRepeat: 'no-repeat', backgroundSize: '100% 100%' }}
                                className='cursor-pointer shadow-[rgba(0,0,15,0.5)_5px_5px_4px_0px] hover:scale-105  duration-300 text-xl text-white uppercase flex w-64 h-16 justify-center items-center mt-10'>
                                GET STARTED
                            </div>
                            <div onClick={() => navigate('/login')} style={{ backgroundImage: `url(${require("../assets/button_arrow.png")})`, backgroundRepeat: 'no-repeat', backgroundSize: '100% 100%' }}
                                className='cursor-pointer hover:scale-105  duration-300 text-xl text-white uppercase flex w-16 h-16 justify-center items-center mt-10'>
                            </div>
                            {/* <img className='h-16' src={require('../assets/button_arrow.png')} /> */}
                        </div>
                    </div>
                </div>
            </div>
            <div style={{ fontFamily: 'MavenPro' }} className='absolute flex flex-col w-full h-[100vh]'>

            </div>
            <div className='w-full h-[100vh] overflow-hidden'>
                <img className='relative max-w-full h-auto left-[565px]' src='/rafce_bg.jpg' />
            </div>
        </>
    )
}
